import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SurveyHealthResponseInterface } from '../interfaces/manage-health-checks.interface';
import { HEALTH_CHECK_STATUS } from '../constants/manage-health-checks.constants';
import { BuyerApiService } from '../../shared/services/buyer-api/survey.service';
@Component({
  selector: 'ps-ui-manage-health-checks',
  templateUrl: './manage-health-checks.component.html',
  styleUrls: ['./manage-health-checks.component.css'],
})
export class ManageHealthChecksComponent implements OnInit {
  @Input() surveyId: number;
  private _subscriptions: Subscription = new Subscription();
  public surveyHealths: SurveyHealthResponseInterface[] = [];
  public healthCheckStatus = HEALTH_CHECK_STATUS;
  constructor(private _buyerApiService: BuyerApiService) {}

  ngOnInit(): void {
    this._getSurveyHealths();
  }

  private _getSurveyHealths() {
    const getSurveyHealth$ = this._buyerApiService
      .getSurveyHealths(this.surveyId)
      .subscribe((surveyHealths: SurveyHealthResponseInterface[]) => {
        this.surveyHealths = surveyHealths;
      });
    this._subscriptions.add(getSurveyHealth$);
  }
}
